// extracted by mini-css-extract-plugin
module.exports = {"container":"Expandable_container__WmDa1","fader":"Expandable_fader__35FyO","toggle":"Expandable_toggle__3-CDE"};